export default __webpack_public_path__ + "img/remove-background.a9a90af9.svg";